import { adminAuthService } from './adminAuthService';

let refreshPromise = null;

const tryRefreshOnce = () => {
  if (!refreshPromise) {
    refreshPromise = fetch('/api/auth/refresh', {
      method: 'POST',
      credentials: 'include',
    }).finally(() => { refreshPromise = null; });
  }
  return refreshPromise;
};

export const adminApiClient = {
  async request(endpoint, options = {}, _isRetry = false) {
    const config = {
      ...options,
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    };

    try {
      const response = await fetch(endpoint, config);
      console.log(endpoint);
      if (response.status === 401) {
        if (_isRetry) {
          adminAuthService.logout();
          return;
        }
        try {
          await tryRefreshOnce();
          return this.request(endpoint, options, true);
        } catch {
          adminAuthService.logout();
          return;
        }
      }

      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        throw new Error(error.message || `Request failed with status ${response.status}`);
      }

      if (response.status === 204) return null;

      return await response.json();
    } catch (err) {
      console.error('Admin API Error:', err);
      throw err;
    }
  },

  get(endpoint)           { return this.request(endpoint, { method: 'GET' }); },
  post(endpoint, data)    { return this.request(endpoint, { method: 'POST',   body: JSON.stringify(data) }); },
  put(endpoint, data)     { return this.request(endpoint, { method: 'PUT',    body: JSON.stringify(data) }); },
  patch(endpoint, data)   { return this.request(endpoint, { method: 'PATCH',  body: JSON.stringify(data) }); },
  delete(endpoint)        { return this.request(endpoint, { method: 'DELETE' }); },
};

export default adminApiClient;
